define('views/modules/note/list/note-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/fetch-list',
    'views/modules/note/list/note-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VFetchList,
    VNoteListItem
) {

    var VNoteList = VFetchList.extend({
        item: VNoteListItem,

        getItemOptions: function(opt) {
            return _.extend(opt, _.pick(this.options, ['group', 'profile']));
        },
    });

    return VNoteList;

});

